<template>
  <div class="row m-4">
    <div class="col-12 col-md-6">
      <grid-stock :isStatusAvailable="isStatusAvailable" :partID="partID" :disabled="!isFormRFQNew" @onAddQuote="handleAddQuote" />
    </div>
    <div class="col-12 col-md-6">
      <grid-rfq-2 :partID="partID" :disabled="!isFormRFQNew" @onAddQuote="handleAddQuoteWithUpdateRFQ2" />
    </div>
    <div class="col-12">
      <manually :partID="partID" :disabled="!isFormRFQNew" @onAddQuote="handleAddQuote" />
    </div>
    <template v-if="isVisibleRFQ">
      <div class="col-xl-8">
        <form-rfq
          :data.sync="dataRFQ"
          :isNew="isFormRFQNew"
          @onCreate="handleCreateRFQ"
          @onClone="handleClone"
          @onChangeCompanyID="handleChangeCompanyID"

        />
      </div>
      <div class="col-xl-4 vb-xl">
        <info-section-table
          :data="listQuotes"
          :fields="infoFields"
        >
          <template v-slot:cell-chosen="{ row }">
            <span class="icon-db" :class="{'is-true': row.chosen !== false, 'is-false': row.chosen === false }"></span>
          </template>
          <template v-slot:cell-price="{ row }">
            {{row.price | toPriceCurrency(dataSourceCurrency.map[row.currencyID] && dataSourceCurrency.map[row.currencyID].title)}}
          </template>
          <template v-slot:row-controls="{ row }">
            <button
              v-if="!isFormRFQNew && !isFormRFQ3New"
              class="btn btn-size-xs"
              @click="sendQuoteToCustomerEmail(row, false)"
            >{{L10n('send-quote-to-customer-email')}}
            </button>
            <button
              class="btn btn-size-xs"
              @click="sendQuoteToCustomerEmail(row, true)"
            >{{L10n('send-quote-no-stock-to-customer-email')}}</button>
          </template>
        </info-section-table>
        <info-section-table :data="companyRemarks" :fields="companyRemarksFields" />
      </div>
    </template>
    <template v-if="!isFormRFQNew">
      <div class="col-12 mt-3">
        <form-rfq3 :data.sync="dataRFQ3" :isNew="isFormRFQ3New" @onCreate="handleCreateRFQ3" @onSave="handleSaveRFQ3" />
      </div>
    </template>
    <!--    Dialogs-->
    <dialog-send-quote-to-customer-email
      ref="dialogSendQuote"
      :rfqID="dataRFQ.id"
      :rfq3ID="dataRFQ3.id"
      @onSuccess="handlerSuccessCustomerEmail"
    ></dialog-send-quote-to-customer-email>
    <dialog-confirm
      ref="dialog-confirm"
      :config="{
        title: L10n('new-rfq'),
        text: L10n('create-new-rfq-from-stretch')
      }"
      @confirm="handlerConfirmClone"
    >
      <template v-slot:footer-confirm="confirmProps">
        <button
          type="button"
          class="btn btn-control btn-border grey btn-size-s"
          @click.prevent="confirmProps.clickHandler('cancel')">
          {{L10n('cancel')}}
        </button>
        <button
          type="button"
          class="btn btn-control btn-border blue btn-size-s"
          ref="btnConfirm"
          @click.prevent="confirmProps.clickHandler('confirm')">
          {{L10n('confirm')}}
        </button>
      </template>
    </dialog-confirm>
  </div>
</template>

<script>
import { ServiceRFQs } from '@/services/RFQs'
import { ModelRFQ, ModelRFQ1 } from '../models'
import { ServiceRFQ1s } from '@/services/RFQ1s'
import { ModelRFQ3, ServiceRFQ3s } from '@/services/RFQ3s'
import { ServiceRFQ2s } from '@/services/RFQ2s'
import { ServiceCompanyRemarks } from '@/services/CompanyRemarks'

export default {
  name: 'index',
  components: {
    'grid-rfq-2': () => import(/* webpackChunkName: 'QuickRFQPart' */ './FromRFQ2'),
    'grid-stock': () => import(/* webpackChunkName: 'QuickRFQPart' */ './FromStock'),
    'manually': () => import(/* webpackChunkName: 'QuickRFQPart' */ './Manually'),
    'form-rfq': () => import(/* webpackChunkName: 'QuickRFQPart' */ './FormRFQ'),
    'form-rfq3': () => import(/* webpackChunkName: 'QuickRFQPart' */ './FormRFQ3'),
    'info-section-table': () => import(/* webpackChunkName: 'InfoSection' */ '@/components/InfoSection/Table.vue'),
    'dialog-send-quote-to-customer-email': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SendQuoteToCustomerEmail/Index'),
    'dialog-confirm': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogConfirm')
  },
  props: {
    isStatusAvailable: { type: Boolean, default: false },
    partID: {
      type: Number,
      required: true
    },
    partNumber: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isUpdateRFQ2: false,
      primaryData: {},
      dataRFQ: {},
      dataRFQ3: {},
      companyRemarks: []
    }
  },
  computed: {
    isFormRFQNew () {
      return !this.dataRFQ.id
    },
    isFormRFQ3New () {
      return !this.dataRFQ3.id
    },
    isVisibleRFQ () {
      return Object.keys(this.primaryData).length > 0
    },
    listQuotes () {
      if (this.isFormRFQNew) {
        return [{ ...this.primaryData, partNumber: this.partNumber }]
      } else if (!this.isFormRFQNew) {
        return [{ ...this.dataRFQ3, partNumber: this.partNumber }]
      } else {
        return []
      }
    },
    infoFields () {
      return [
        { title: this.L10n('include-in-po'), fieldName: 'chosen' },
        { title: this.L10n('part-number'), fieldName: 'partNumber' },
        { title: this.L10n('qty'), fieldName: 'qty' },
        { title: this.L10n('price'), fieldName: 'price' }
      ]
    },
    companyRemarksFields () {
      return [
        { title: this.L10n('remark'), fieldName: 'remark' }
      ]
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    }
  },
  methods: {
    handleChangeCompanyID (id) {
      if (id) {
        return this.loadCompanyRemarks({ companyID: id })
      }
      this.companyRemarks = []
    },
    async loadCompanyRemarks ({ companyID }) {
      try {
        const result = await ServiceCompanyRemarks
          .getAllDynamic({ select: 'remark', filter: `remarkSubjectID==10 && companyID==${companyID}` })
        this.companyRemarks = result.data.value
      } catch (e) {
        this.requestErrorHandler(e)
      }
    },
    handleAddQuote (data) {
      this.isUpdateRFQ2 = false
      this.primaryData = { ...data }
    },
    handleAddQuoteWithUpdateRFQ2 (data) {
      this.isUpdateRFQ2 = true
      this.primaryData = { ...data }
    },
    sendQuoteToCustomerEmail (data, noStock) {
      if (this.isFormRFQNew || this.isFormRFQ3New) {
        this.$bus.$emitPromise('getRFQFormData')
          .then((rfqFormData) => {
            const dataRFQ = rfqFormData[0] || {}
            this.$refs.dialogSendQuote.show({ noStock, staticRFQData: { ...dataRFQ, partNumber: this.partNumber } })
          })
      } else {
        this.$refs.dialogSendQuote.show({ noStock })
      }
    },
    handleClone (data) {
      this.$refs['dialog-confirm'].show(data)
    },
    async handleCreateRFQ (data) {
      this.$emit('update:isLoading', true)
      try {
        await this.requestCreateRFQ(data)
        this.dataRFQ3 = { ...this.primaryData, rfqid: this.dataRFQ.rfqid, id: null }
        const { rfqid } = this.dataRFQ
        const dataRFQ1 = { ...this.primaryData, rfqid }
        await ServiceRFQ1s.post(this.copyObjectProps(ModelRFQ1(), dataRFQ1))
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.$emit('update:isLoading', false)
      }
    },
    async requestCreateRFQ (data) {
      const _data = this.copyObjectProps(ModelRFQ(), { ...data })
      const { data: createdDataRFQ } = await ServiceRFQs.createRFQ(_data)
      this.dataRFQ = createdDataRFQ
      return createdDataRFQ
    },
    async handlerConfirmClone (data) {
      let _data = { ...data }
      delete _data['id']
      delete _data['rfqid']
      await this.handleCreateRFQ(_data)
      this.dataRFQ3 = {}
    },
    async handleCreateRFQ3 (dataRFQ3) {
      this.$emit('update:isLoading', true)
      const { rfqid } = this.dataRFQ
      try {
        const _dataRFQ3 = { ...dataRFQ3, quoteDate: new Date() }
        const { data: dataCreatedRFQ3 } = await ServiceRFQ3s.post(this.copyObjectProps(ModelRFQ3(), _dataRFQ3))

        this.dataRFQ3 = dataCreatedRFQ3

        if (this.isUpdateRFQ2) {
          const { id } = this.primaryData
          await ServiceRFQ2s.patch({ chosen: true, rfqid, id })
        }
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.$emit('update:isLoading', false)
      }
    },
    async handleSaveRFQ3 (dataRFQ3) {
      this.$emit('update:isLoading', true)
      try {
        const { data: dataUpdatedRFQ3 } = await ServiceRFQ3s.post(this.copyObjectProps(ModelRFQ3(), dataRFQ3))

        this.dataRFQ3 = dataUpdatedRFQ3
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.$emit('update:isLoading', false)
      }
    },
    async handlerSuccessCustomerEmail () {
      if (!this.dataRFQ3.id) {
        this.dataRFQ3 = { ...this.dataRFQ3, sendMail: true }
        return
      }
      this.$emit('update:isLoading', true)
      try {
        const { data: dataRFQ3 } = await ServiceRFQ3s.get(this.dataRFQ3.id)

        this.dataRFQ3 = dataRFQ3
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.$emit('update:isLoading', false)
      }
    }
  }
}
</script>
